var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlexPay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0783 16.338H4.21569L4.15848 16.3372C2.96123 16.3061 2 15.3003 2 14.064V8.72024C2 7.484 2.96123 6.47819 4.15848 6.44705L4.21569 6.44629H13.0783L13.1356 6.44705C14.3328 6.4782 15.294 7.48401 15.294 8.72024V14.064L15.2933 14.1227C15.2634 15.3319 14.3138 16.3065 13.1356 16.3372L13.0783 16.338ZM13.1969 8.24461H4.12387C3.95353 8.24461 3.81544 8.38607 3.81544 8.56057V14.2478C3.81544 14.4223 3.95353 14.5638 4.12387 14.5638H13.1969C13.3673 14.5638 13.5054 14.4223 13.5054 14.2478V8.56057C13.5054 8.38607 13.3673 8.24461 13.1969 8.24461Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.842 3.66264C17.0392 3.69379 18.0005 4.69958 18.0005 5.93582V11.2796L17.9997 11.3383C17.973 12.4186 17.2122 13.3116 16.2101 13.5116L16.1982 5.78763C16.1979 5.60115 16.0467 5.45012 15.8602 5.45012H4.77539C4.96228 4.4113 5.80508 3.6902 6.86489 3.66264L6.92211 3.66187H15.7848L15.842 3.66264Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlexPay);
export default __webpack_public_path__ + "static/media/flex-pay.5d4d532ffd91f3648a2169b678440a7b.svg";
export { ForwardRef as ReactComponent };